<template>
  <h-msg-box
    v-model="showModal"
    width="480"
    class="financial-competition-modal"
    :mask-closable="false"
  >
    <p slot="header">
      <span class="model-header">队伍查找方法</span>
    </p>
    <div class="model-content">
      <ol>
        <li>若有同事已作为队长创建队伍可直接问他索要加队链接</li>
        <li>若你还未找到组织可以申请加入微信群，我们会协助你完成组队</li>
      </ol>
      <div class="model-img">
        <img alt="wechat" :src="wechatGroupQrCode" />
        <span class="dingding">
          <!-- <a-icon type="dingtalk-circle" theme="filled" class="dingding-icon" /> -->
          <!-- <h-icon name="social-twitter" class="dingding-icon"></h-icon> -->
          微信扫码入群
        </span>
      </div>
    </div>
    <div slot="footer">
      <comp-button class="btn-icon" @click="showModal = false"
        >知道了</comp-button
      >
    </div>
  </h-msg-box>
</template>

<script>
import { CompButton } from '../common'

export default {
  name: 'JoinTeamSearch',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showModal: false,
      wechatGroupQrCode: window.financialCompetitionResource.wechatGroupQrCode
    }
  },
  components: {
    CompButton
  },
  created() {
    this.showModal = this.value
  },
  methods: {},
  watch: {
    value(newValue, oldValue) {
      this.showModal = newValue
    },
    showModal(val) {
      this.$emit('input', val)
    }
  }
}
</script>

<style lang="scss" scoped>
.model-header {
  font-family: 'PingFangSC-Medium', Arial, 'Microsoft Yahei', sans-serif,
    Verdana, 'PingFang SC';
  font-size: 16px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 24px;
}
.model-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  > ol {
    list-style: decimal;
    font-family: 'PingFangSC-Regular', Arial, 'Microsoft Yahei', sans-serif,
      Verdana, 'PingFang SC';
    font-size: 14px;
    color: #333333;
    line-height: 22px;
    li {
      margin: 8px 0;
    }
  }
  > .model-img {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 40px;
    > img {
      width: 131px;
      height: 129px;
    }
    > .dingding {
      margin-top: 8px;
      font-family: 'PingFangSC-Regular', Arial, 'Microsoft Yahei', sans-serif,
        Verdana, 'PingFang SC';
      font-size: 14px;
      color: #333333;
      line-height: 22px;
      .dingding-icon {
        color: #3296fa;
        margin-right: 5px;
        font-size: 14px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/gtn/views/financialCompetitionViews/components/TeamUp/JoinTeamSearch.vue